// src/components/resources/RequestAccessLink.tsx

import Link from 'next/link'
import { siteConfig } from '~/lib/config/site'

interface RequestAccessLinkProps {
  /** Link label. Defaults to the standard early-access wording. */
  label?: string
  /** Extra classes appended to the shared link styling. */
  className?: string
}

/**
 * Shared "Request early access →" link to the core-platform conversion
 * surface (`/request-access`). Extracted so the contextual upsell CTAs on
 * glossary term pages and calculator pages share one styled anchor (href,
 * arrow, indigo + dark-mode treatment) and can't drift. Renders in both
 * server (HowAdSightsHelpsCard) and client (CalculatorLayout) trees.
 */
export function RequestAccessLink({
  label = 'Request early access',
  className = ''
}: RequestAccessLinkProps): JSX.Element {
  return (
    <Link
      href={siteConfig.baseLinks.requestAccess}
      className={`inline-flex items-center gap-1 text-sm font-semibold text-indigo-700 hover:text-indigo-600 dark:text-indigo-300 dark:hover:text-indigo-200 ${className}`.trim()}
    >
      {label}
      <span aria-hidden="true">→</span>
    </Link>
  )
}

export default RequestAccessLink
